import {app} from '../../app';
import { Controller } from './show-note.controller';

app.component('showNote', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./show-note.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/show-note/show-note.component.js